module.exports = __webpack_public_path__ + "img/us.b33cef27.svg";